var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(45, 48, 146, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(30, 32, 99, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M17.8,-22.7C23.1,-24.2,27.6,-19.4,26.2,-14.4C24.8,-9.3,17.5,-3.9,16.2,2C14.9,8,19.6,14.5,19.5,19.7C19.4,24.9,14.5,28.7,8.6,31.2C2.8,33.8,-3.9,35,-9.9,33.4C-15.9,31.8,-21.2,27.4,-24.8,22.1C-28.4,16.9,-30.3,10.8,-29.7,5.2C-29.1,-0.4,-25.9,-5.4,-20.9,-6.7C-15.8,-8,-8.9,-5.5,-5.1,-4.7C-1.3,-3.9,-0.7,-4.7,2.8,-9C6.2,-13.3,12.4,-21.2,17.8,-22.7Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    },
    stroke: "url(#sw-gradient)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitBook);
export default __webpack_public_path__ + "static/media/fitBook.a8e7f645b837d258608fd221df5457b1.svg";
export { ForwardRef as ReactComponent };